// extracted by mini-css-extract-plugin
export default {"form-container":"edit-insurance-page_form-container__Fmqj6","labeled-input-wrapper":"edit-insurance-page_labeled-input-wrapper__n4CUz"};